import { NoResults } from "components/page-components/Internal-Search/utils"
import React from "react"
import { connectStateResults } from "react-instantsearch-dom"

export const CheckResults = connectStateResults(
  ({ searchState, setSearchState, searchResults, set_focussed, children }) =>
    searchResults && searchResults.nbHits !== 0 ? (
      children
    ) : searchState.query ? (
      <NoResults {...{ setSearchState, set_focussed }} />
    ) : (
      <div></div>
    )
)
